import { GeoType, LocationType } from '../../models';

export const SearchByPropertyParamsByRegion = {
    compose(type = LocationType.OTHERS, dedupId) {
        if (GeoType.ACCOMMODATION !== type || !dedupId) {
            return '';
        }
        const accommodationParam = encodeURIComponent(`${dedupId}+SearchByProperty`);
        return `accommodation=${accommodationParam}`;
    },
};
